import React, { FunctionComponent, SVGProps, useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import Dots from '@/assets/img/dots-3.svg';
import './QuotesFilter.scss';
import ActionIcon from '@/assets/rewise/action-btn.svg';
import Delete from '@/assets/steam/delete.svg';
import { default as ReactSelect, components } from 'react-select';
import FilterIcon from '@/assets/steam/filter.svg';
import { ReactComponent as Calendericon } from '@/assets/steam/calender-frame.svg';
import DatePicker, { DayRange } from 'react-modern-calendar-datepicker';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import { City, State, UserRole } from '@/features/users/types/indes';
import { useGetCityList } from '@/features/users/api/getRefrences';
import { User } from '@/types';
import moment from 'moment';

import Checkmark from '@/assets/steam/green-check.png';

export type ActionMenu = {
  label: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>>;
  onClickHandler: (params: any) => any;
  itemClassName: string;
};

type ActionMenuProps = {
  options?: ActionMenu[];
  isDropdown?: boolean;
  isVerticalIcon?: boolean;
  roles?: any;
  usersList?: any;
  onRoleSelect: (filter: any) => void;
  showRoleFilter?: boolean;
  instituteList?: any;
  showInstitute:boolean;

};

export const QuotesFilter = ({ showInstitute,instituteList,options, isDropdown = true, isVerticalIcon, roles, usersList, onRoleSelect, showRoleFilter = true }: ActionMenuProps) => {
  const [selectedRole, setSelectedRole] = useState<any[]>()
  const [cities, setCities] = useState<any[]>()
  const [selectedUsers, setSelectedUsers] = useState<User[]>();
  const [selectedFunnelType, setSelectedFunnelType] = useState<any[]>();
  const [selectedDateType, setSelectedDateType] = useState<any[]>();
  const useGetCityMutation = useGetCityList();
  const [delaSize, setDealSize] = useState<any>('');
  const [selectedDate, setSelectedDate] = useState<any>();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [setFunnelStages, setStages] = useState<any[]>();
  const [selectedInstitute, setSelectedInstitute] = useState<any[]>()




  const clearFilter = () => {
    setSelectedUsers([]);
    setSelectedInstitute([])
    setSelectedRole([]);
    setSelectedFunnelType([]);
    setStages([]);
    setDealSize('')
    setSelectedDate('')
    setSelectedDateType([]);
    onRoleSelect(null)
    setIsDropdownOpen(false);
  }


  useEffect(() => {
    if (selectedRole || selectedUsers || selectedInstitute ) {
      applyFilter();
    }
  }, [selectedRole,selectedUsers,selectedInstitute ]);

  const applyFilter = () => {
    const rolesIds = selectedRole && selectedRole.length > 0 ? selectedRole.map((item: any) => Number(item.id)) : [];
    const userIds = selectedUsers && selectedUsers.length > 0 ? selectedUsers.map((item: any) => Number(item.id)) : [];
    const instituteIds = selectedInstitute && selectedInstitute.length > 0 ? selectedInstitute.map((item: any) => Number(item.id)) : [];
   // setIsDropdownOpen(false)
    onRoleSelect({ 'statusIds': rolesIds, 'userId': userIds, 'instituteIds' :instituteIds })
  }

  const isShowfilerCheck = () =>{
    if(selectedRole && selectedRole.length > 0){
      return true
    }else if(selectedUsers && selectedUsers.length > 0){
      return true
    }else if (selectedInstitute && selectedInstitute.length>0){
      return true
    }else{
      return false
    }
  }

  return (
    <>
      <Dropdown className={`funnel-filter-menu dot-3-btn ${isVerticalIcon ? 'is-vertical-icon' : ''}`}  show={isDropdownOpen}
        onToggle={(isOpen) => setIsDropdownOpen(isOpen)}>
        <Dropdown.Toggle id="dropdown-basic" className="dots-3-icon btn-1">
          <img src={isVerticalIcon ? FilterIcon : FilterIcon} className="filter-icon fixed-width" />
          {isShowfilerCheck() &&  <img src={Checkmark} className='green-checkmark'/>}
        </Dropdown.Toggle>
        <Dropdown.Menu className="drop-down-backdrop">
          <div className="action-no-dropdown-funnel">

          {showInstitute && <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
                className="multiselect-react funnel-filter-width"
                options={instituteList ? instituteList : []}
                isMulti={true}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedInstitute(selected);
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option4,
                  ValueContainer: ValueContainer4,
                }}
                placeholder={'Select status'}
                value={selectedInstitute}

              />

            </div>}
            <div className="user-first-last-div petsked-form mb-3">
              <ReactSelect
               closeMenuOnSelect={false}
                className="multiselect-react funnel-filter-width"
                options={roles ? roles : []}
                isMulti={true}
                hideSelectedOptions={false}
                classNamePrefix={'petsked-multiselect'}
                onChange={(selected: any) => {
                  setSelectedRole(selected);
                }}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
                components={{
                  Option: Option1,
                  ValueContainer: ValueContainer1,
                }}
                placeholder={'Select status'}
                value={selectedRole}

              />

            </div>


            <div>


              <div className="user-first-last-div petsked-form mb-3">
                <ReactSelect
                  className="multiselect-react funnel-filter-width"
                  options={usersList ? usersList : []}
                  isMulti={true}
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  classNamePrefix={'petsked-multiselect'}
                  onChange={(selected: any) => {
                    setSelectedUsers(selected);
                  }}
                  getOptionLabel={(option) => option.name}
                  getOptionValue={(option) => option.id}
                  components={{
                    Option: Option,
                    ValueContainer: ValueContainer,
                  }}
                  placeholder={'Select user'}
                  value={selectedUsers}

                />

              </div>
            </div>

            {/* <div className='minimum-deal-size-field'>
              <div className='input-data'>
                <input
                  className={`custome-input change-font`}
                  placeholder={'Minimum Deal size'}
                  onChange={(e) => {
                    setDealSize(e.target.value);
                  }}
                  value={delaSize}
                  id="dealSize"
                />
              </div>

            </div> */}

            {/* <div className='minimum-deal-size-field date-selector'>
              <DatePicker
                formatInputText={formatDateRange}
                value={selectedDate}
                onChange={(newDate: any) => {
                  if (newDate) {
                    setSelectedDate(newDate);
                  }
                }}
                inputPlaceholder="Select date"
                inputClassName='steam-rangepicker'
                colorPrimary="#002083"
                colorPrimaryLight="#002083"
              />
            </div> */}


          </div>


          <div className='action-filter-funnel'>
            <button onClick={() => { applyFilter() }} className='steam-button button-dark' >

              {/* <SearchIcon /> */}
              Search
            </button>
            <button onClick={() => { clearFilter() }} className='steam-button invert-button'>
              {/* <img src={Delete} className='filter-clear-icon' /> */}
              Reset
            </button>
          </div>
        </Dropdown.Menu>
      </Dropdown>

    </>
  );
};

const Option = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select users</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added Users`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};



const Option1 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer1 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select status</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added status`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};




const Option4 = (props: any) => {
  const {
    data: { avatarUrl, name, email },
  } = props;
  return (
    <div key={`options-sp${props.value}`}>
      <components.Option {...props}>
        <div className="service-provider-option">
          <div className="left-details">
            {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
            <span>
              <label className="name">{name}</label>
              {/* <label className="email">{email}</label> */}
            </span>
          </div>
          <div>
            <label htmlFor={`option-check-${props.value}`} className="check-container">
              <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
              <span className="checkmark"></span>
            </label>
          </div>
        </div>
      </components.Option>
    </div>
  );
};
const ValueContainer4 = (props: any) => {
  const valueLength = props.getValue().length;
  return (
    <components.ValueContainer {...props}>
      {valueLength === 0 && <span className="react-select-custom-placeholder">Select institutes</span>}
      {props.getValue().length > 0 &&
        !props.selectProps.inputValue &&
        `+${valueLength} added institutes`}
      {React.Children.map(props.children, (child) => {
        if (child) {
          return child.type === components.Input ? child : null;
        }
      })}
    </components.ValueContainer>
  );
};




QuotesFilter.displayName = 'QuotesFilter';
